import * as React from "react";
import { ButtonBase, styled } from "@mui/material";
import { Colors } from "../../../../Themes/colors";

interface IBoxButtonProps {
	label: string;
	onClick: () => void;
	selected: boolean;
	className?: string;
}

export const BoxButton: React.FC<IBoxButtonProps> = ({
	label,
	onClick,
	selected,
	className,
}) => {
	return (
		<StyledButton
			className={`box-button${className ? ` ${className}` : ""}`}
			onClick={onClick}
			selected={selected}
			disableRipple={false}
		>
			{label}
		</StyledButton>
	);
};

const StyledButton = styled(ButtonBase, {
	shouldForwardProp: (prop) => prop !== "selected",
})<{ selected: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 244px;
    height: 94px;
	padding: 0 16px;
	border-radius: 4px;
	font-family: "NORLYSText-Regular", sans-serif;
	font-size: 1rem;
	cursor: pointer;
	transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

	background-color: ${({ selected }) => (selected ? Colors.greenStrong : Colors.white)};
	border: 2px solid ${({ selected }) => (selected ? Colors.greenStrong : Colors.grey30)};
	color: ${({ selected }) => (selected ? Colors.white : Colors.grey100)};

	&:hover {
		background-color: ${({ selected }) => (selected ? Colors.greenStrong : Colors.grey05)};
	}

	&:focus-visible {
		outline: 2px solid ${Colors.greenDark};
		outline-offset: 2px;
	}
`;
